import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Scrollable from '@component/scrollable';

const LanguagePickerItems = ({
  languages,
  currentLanguage,
  changeLanguage,
}) => (
  <Scrollable>
    <ul className="languagepicker__list">
      {languages.map((language) => (
        <li
          key={'language_changer_' + language.value}
          className={classnames({
            'tooltip__active-item': currentLanguage.value === language.value,
          })}
          onClick={() => changeLanguage(language.value)}
          data-value={language.value}
        >
          {language.label}
        </li>
      ))}
    </ul>
  </Scrollable>
);

const languageShape = PropTypes.shape({
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
});

export const propTypes = {
  currentLanguage: languageShape.isRequired,
  languages: PropTypes.arrayOf(languageShape).isRequired,
  changeLanguage: PropTypes.func.isRequired,
};

LanguagePickerItems.propTypes = propTypes;

export default LanguagePickerItems;
